import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EnvironmentalConditionService } from 'app/services/models/environmental-condition.service';
import { KindService } from 'app/services/models/kind.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-environmental-condition',
  templateUrl: './create-environmental-condition.component.html',
  styleUrls: ['./create-environmental-condition.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateEnvironmentalConditionComponent implements OnInit {
  @Input() data;
  environmentalConditions = [
    { name: '', start: null, end: null }
  ];
  selectedType: any = null;

  kinds: any[] = [];
  constructor(
    public activeModal: NgbActiveModal,
    private kindService: KindService,
    private environmentalConditionService: EnvironmentalConditionService,
    private toastService: ToastrService
  ) { }

  async ngOnInit() {
    await this.getAllKinds();
    if (this.data) {
      await this.getByIdEnvironmentalCondition(this.data);
    }
  }

  async getByIdEnvironmentalCondition(id) {
    const data = await this.environmentalConditionService.getByIdEnvironmentalCondition(id);
    console.log(data);
    this.environmentalConditions = data.enviromentalContent;
    this.selectedType = data.kindId
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 100, 13);
    console.log(data);
    this.kinds = data.types;
  }

  closeModal() {
    this.activeModal.close(false);
  }

  addEnvironmentalCondition() {
    this.environmentalConditions.push({ name: '', start: null, end: null });
  }

  removeEnvironmentalCondition(index: number) {
    this.environmentalConditions.splice(index, 1);
  }

  async saveEnvironmentalConditions() {
   
    console.log(this.selectedType);
    console.log('Kaydedilen çevre şartları:', this.environmentalConditions);

    if (this.data) {
      const data = await this.environmentalConditionService.update(this.data,this.selectedType, this.environmentalConditions);
      if (data.status) {
        this.environmentalConditionService.sendEvent(true);
        this.toastService.success(data.message);
        this.closeModal();
      } else {
        this.toastService.error(data.error);
      }
    } else {
      const data = await this.environmentalConditionService.create(this.selectedType, this.environmentalConditions);
      if (data.status) {
        this.environmentalConditionService.sendEvent(true);
        this.toastService.success(data.message);
        this.closeModal();
      } else {
        this.toastService.error(data.error);
      }
    }
  }
}
